<h2 mat-dialog-title>Dados do atendimento - {{ data.param.encounter.name }}</h2>
<mat-dialog-content class="mat-typography">
  <mat-tab-group>
    <mat-tab label="Dados do Atendimento">
      <div class="info">
        <div class="row" *ngIf="encounter.byOrderInfo.isByOrder == false">
          <div class="col-md-4 col-lg-2">Data e Hora:</div>
          <div class="col-md-8 col-lg-10">{{ layout.dateTimeFormat(encounter.plannedStartDate) || '-' }}</div>
        </div>
        <div class="row" *ngIf="encounter.byOrderInfo.isByOrder == true">
          <div class="col-md-4 col-lg-2">Data e Hora:</div>
          <div class="col-md-8 col-lg-10">
            {{ layout.dateFormat(encounter.plannedStartDate) || '-' }} - Atendimento por ordem de chegada a partir de
            {{ layout.plannedStartHourFormat(encounter.byOrderInfo.startServiceHour) }}
          </div>
        </div>
        <div *ngIf="encounter.organization.name == encounter.practitioner.name" class="row">
          <div class="col-md-4 col-lg-2">Realizado por:</div>
          <div class="col-md-8 col-lg-10">{{ encounter?.practitioner?.name ? encounter.practitioner.name : '-' }}</div>
        </div>
        <div *ngIf="encounter.organization.name != encounter.practitioner.name" class="row">
          <div class="col-md-4 col-lg-2">Especialista:</div>
          <div class="col-md-8 col-lg-10">{{ encounter?.practitioner?.name ? encounter.practitioner.name : '-' }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Especialidade:</div>
          <div class="col-md-8 col-lg-10">{{ encounter?.servicetype_name ? encounter.specialty : encounter?.servicecategory_name || '-' }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Procedimento:</div>
          <div class="col-md-8 col-lg-10">{{ encounter?.name ? encounter.name : '-' }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Valor:</div>
          <div class="col-md-8 col-lg-10">R$ {{ encounter?.value }}</div>
        </div>
        <div class="row" *ngIf="encounter.agreement_approved">
          <div class="col-md-4 col-lg-2">Valor a ser pago:</div>
          <div class="col-md-8 col-lg-10">R$ {{ encounter?.value_agreement }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Forma de agendamento:</div>
          <div class="col-md-8 col-lg-10">{{ encounter?.scheduling_method ?? '-' }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Forma de pagamento:</div>
          <div class="col-md-8 col-lg-10">{{ formatPaymentMethod(encounter.paymentMethod) }}</div>
        </div>
      </div>
      <page-map-view [latLong]="this.latLong" [address]="organizationLocation?.address" [googleMapUrl]="organizationLocation?.mapUrl"></page-map-view
      ><br /><br />
    </mat-tab>

    <mat-tab label="Informações Plano de Saúde" *ngIf="encounter.scheduling_method == 'CONVENIO'">
      <div class="info" *ngIf="encounter">
        <div class="row">
          <div class="col-md-4 col-lg-2">Nome do paciente:</div>
          <div class="col-md-8 col-lg-10">{{ encounter.health_plan.patient_name ?? '-' }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Data de nascimento:</div>
          <div class="col-md-8 col-lg-10">{{ (encounter.health_plan.birth_date | mask: '00/00/0000') || '-' }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Convênio:</div>
          <div class="col-md-8 col-lg-10">{{ encounter.health_plan.health_plan_name }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Modalidade:</div>
          <div class="col-md-8 col-lg-10">{{ encounter.health_plan.agreement }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Número Cartão:</div>
          <div class="col-md-8 col-lg-10">{{ encounter.health_plan.card_number | mask: '0 000 0000000000000' }}</div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Reagendamento" *ngIf="data.param.encounter.status == 'planned'">
      <div class="row rowTime">
        <div class="col-xs-12 col-sm-6 col-md-4">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Escolha a data</mat-label>
            <input
              matInput
              [matDatepickerFilter]="dateFilter"
              [matDatepicker]="picker"
              [(ngModel)]="hour.date"
              readonly
              (dateChange)="onDateChange($event)"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker [dateClass]="dateClass" #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-4" *ngIf="!isByOrder">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Horários disponíveis</mat-label>
            <mat-select [(value)]="hour.time" [disabled]="!hour.date">
              <mat-option *ngFor="let item of hours" [value]="item.timeStart" [disabled]="isTimeDisabled(item.timeStart)">
                {{ item.timeStart }} - {{ item.timeEnd }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-4">
          <button
            mat-flat-button
            color="primary"
            (click)="reagendamento()"
            [disabled]="loading || (isByOrder ? !hour.date : !hour.date || !hour.time)"
            class="btReagendar"
          >
            <span *ngIf="!loading">Reagendar</span>
            <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
          </button>
        </div>
      </div>
    </mat-tab>

    <mat-tab
      *ngIf="encounter.status == 'planned' && encounter.organization.organization_id == encounter.practitioner.practitioner_id"
      label="Reagendamento"
    >
      <div class="row rowTime">
        <div class="col-xs-12 col-sm-6 col-md-4">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Escolha a data</mat-label>
            <input
              matInput
              [matDatepickerFilter]="organizationDateFilter"
              [matDatepicker]="picker"
              [(ngModel)]="hour.date"
              readonly
              (dateChange)="onDateChange($event)"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker [dateClass]="dateClass" #picker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Horários disponíveis</mat-label>
            <mat-select [(value)]="hour.time">
              <mat-option
                *ngFor="let item of hours"
                [value]="item.timeStart"
                [disabled]="
                  isBlockedDate(hour.date) ||
                  (disabledTimes && disabledTimes.includes(item.timeStart)) ||
                  hours.length == 0 ||
                  disabledMinuts(item.timeStart)
                "
              >
                {{ item.timeStart }} - {{ item.timeEnd }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4">
          <button mat-flat-button color="primary" (click)="reagendamento()" [disabled]="loading || !hour.time" class="btReagendar">Reagendar</button>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Receitas" *ngIf="encounter.status == 'finished'">
      <div class="row">
        <div class="col-xs-8 col-md-10">
          <page-title [title]="titleMedications"></page-title>
        </div>
      </div>
      <div *ngFor="let medication of medications">
        <mat-card>
          <div class="col-xs-6 col-md-6">
            <mat-form-field class="cards" appearance="outline">
              <mat-label>Nome da medicação</mat-label>
              <input type="text" matInput readonly [(ngModel)]="medication.medicationName" placeholder="Nome" />
            </mat-form-field>
          </div>
          <div class="col-xs-6 col-md-6">
            <mat-form-field class="cards" appearance="outline">
              <mat-label>Tipo da medicação</mat-label>
              <input type="text" matInput readonly [(ngModel)]="medication.medicationType" placeholder="Comprimido, gotas, etc..." />
            </mat-form-field>
          </div>
          <div class="col-xs-6 col-md-6">
            <mat-form-field class="cards" appearance="outline">
              <mat-label>Dosagem</mat-label>
              <input type="text" matInput readonly [(ngModel)]="medication.dosage" placeholder="Número de gotas, quantidade de comprimidos, etc..." />
            </mat-form-field>
          </div>
          <div class="col-xs-6 col-md-6">
            <mat-form-field class="cards" appearance="outline">
              <mat-label>Uso</mat-label>
              <input type="text" matInput readonly [(ngModel)]="medication.use" placeholder="Uso da medicação(manhã, após o café, etc...)" />
            </mat-form-field>
          </div>
          <div class="col-xs-6 col-md-6">
            <mat-form-field class="cards" appearance="outline">
              <mat-label>Recomendação</mat-label>
              <input type="text" matInput readonly [(ngModel)]="medication.recommendation" placeholder="Recomendações acerta da medicação" />
            </mat-form-field>
          </div>
        </mat-card>
      </div>
    </mat-tab>

    <mat-tab label="Observação">
      <div class="observation-container">
        <div class="observation-label">
          <p>Suas observações:</p>
          <textarea matInput rows="5" [(ngModel)]="encounter.diagnosis" placeholder="Observação" readonly>{{ encounter.diagnosis }}</textarea>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Comprovante de pagamento" *ngIf="paymentData?.status == 'PAID'">
      <div class="info payment-receipt" *ngIf="paymentData">
        <div class="row">
          <div class="col-md-4 col-lg-2">Status:</div>
          <div class="col-md-8 col-lg-10">Pagamento confirmado</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Valor pago:</div>
          <div class="col-md-8 col-lg-10">R$ {{ formatPaidPaymentValue(paymentData.value) }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Forma de pagamento:</div>
          <div class="col-md-8 col-lg-10">{{ formatPaidPaymentMethod(paymentData) }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Data do pagamento:</div>
          <div class="col-md-8 col-lg-10">{{ formatPaidPaymentDate(paymentData) }}</div>
        </div>
        <div class="row" *ngIf="paymentData.payment_id">
          <div class="col-md-4 col-lg-2">Identificador:</div>
          <div class="col-md-8 col-lg-10">{{ paymentData.payment_id }}</div>
        </div>
        <div class="row" *ngIf="paymentData.order_id">
          <div class="col-md-4 col-lg-2">Pedido:</div>
          <div class="col-md-8 col-lg-10">{{ paymentData.order_id }}</div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions align="end" class="schedule-details-actions">
  <!-- <button *ngIf="encounter.status != 'finished'" mat-flat-button color="primary" (click)="openScheduleChangeMethodDialog()">
    Trocar forma de agendamento
  </button> -->
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
  <button
    mat-flat-button
    color="warn"
    *ngIf="encounter.status === 'planned' && encounter.status_payment != 'PAID'"
    cdkFocusInitial
    (click)="cancelSchedule()"
  >
    Cancelar atendimento
  </button>
</mat-dialog-actions>
